import { render, staticRenderFns } from "./RecipientsSelect.vue?vue&type=template&id=6436818d&scoped=true&"
import script from "./RecipientsSelect.vue?vue&type=script&lang=js&"
export * from "./RecipientsSelect.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsSelect.vue?vue&type=style&index=0&id=6436818d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436818d",
  null
  
)

export default component.exports